export { default } from './Tab'


// WEBPACK FOOTER //
// ./src/components/Tab/index.js